import type { ComponentType } from "react"
import {
	IconAtom2Fill18,
	IconBookOpenFill18,
	IconChatBubbleFill18,
	IconCopiesFill18,
	IconGlobeFill18,
	IconInboxFill18,
	IconLanguageFill18,
	IconLifeRingFill18,
	IconStackPerspectiveFill18,
	IconMessageFill18,
	IconPenSparkleFill18,
	IconRoadmapFill18,
	IconServerFill18,
	IconShareLeftFill18,
	IconShieldKeyFill18,
	IconStopwatchFill18,
} from "nucleo-ui-fill-18"

import { GitHubIcon } from "@productlane/ui/src/icons/github-logo"
import { HubspotIcon } from "@productlane/ui/src/icons/hubspot-icon"
import { IntercomIcon } from "@productlane/ui/src/icons/intercom-logo"
import { LinearIcon } from "@productlane/ui/src/icons/linear-logo"
import { MicrosoftTeamsLogo } from "@productlane/ui/src/icons/microsoft-teams-logo"
import { PlainLogo } from "@productlane/ui/src/icons/plain-logo"
import { AttioIcon } from "@productlane/ui/src/icons/project/attio-logo-icon"
import { CursorIcon } from "@productlane/ui/src/icons/project/cursor-icon"
import { SlackIcon } from "@productlane/ui/src/icons/slack-logo"

type IconComponent = ComponentType<{ className?: string }>

export const FEATURE_ICONS: Record<string, IconComponent> = {
	"Productlane Agent": IconAtom2Fill18,
	"AI drafts": IconPenSparkleFill18,
	Docs: IconBookOpenFill18,
	Changelog: IconStackPerspectiveFill18,
	Requests: IconRoadmapFill18,
	"Support Portal": IconLifeRingFill18,
	Widget: IconChatBubbleFill18,
	"Live Chat": IconMessageFill18,
	"Email inbox": IconInboxFill18,
	"Custom domain": IconGlobeFill18,
	SLAs: IconStopwatchFill18,
	SSO: IconShieldKeyFill18,
	"Multi-language": IconLanguageFill18,
	Linear: LinearIcon,
	"Reply within Linear": IconShareLeftFill18,
	Slack: SlackIcon,
	"Microsoft Teams": MicrosoftTeamsLogo,
	Hubspot: HubspotIcon,
	Plain: PlainLogo,
	Intercom: IntercomIcon,
	Cursor: CursorIcon,
	GitHub: GitHubIcon,
	Attio: AttioIcon,
	"MCP Server": IconServerFill18,
	"Multiple portals": IconCopiesFill18,
}

export const FEATURE_ORDER = Object.keys(FEATURE_ICONS)
